import type { InputDropdownOption } from '@interxfi/design-system/components/input/shared/dropdown/input-dropdown';

export type DataValueKeyOrGetter<TItem, TItemValueKey extends (keyof TItem & string) | undefined = undefined> = TItemValueKey extends keyof TItem &
  string
  ? TItemValueKey
  : (data: TItem) => string;

export type OptionDisplayBuilder<TItem> = (data: TItem) => Omit<InputDropdownOption, 'value'>;

export function getDataValueKey<TItem, TItemValueKey extends keyof TItem | undefined>(
  item: TItem,
  valueOrGetter: TItemValueKey | ((i: TItem) => string),
): string {
  if (typeof valueOrGetter === 'function') {
    return valueOrGetter(item);
  }

  return item[valueOrGetter as keyof TItem] as unknown as string;
}

export function buildOption<TItem, TItemValueKey extends (keyof TItem & string) | undefined = undefined>(
  data: TItem,
  valueOrGetter: DataValueKeyOrGetter<TItem, TItemValueKey>,
  optionDisplayBuilder: OptionDisplayBuilder<TItem> | undefined,
): InputDropdownOption {
  const value = getDataValueKey(data, valueOrGetter);

  return {
    value,
    label: value,
    ...optionDisplayBuilder?.(data),
  };
}
